<template>
   <div class="part4_2_main_box">
        <P class="main_title">2、学习焦虑</P>
        <div class="part4_2_main">
            <div class="norm_box">
                <div class="norm_canvas">
                    <canvas id="canvasId" width="254" height="201"></canvas>
                    <div class="pointer" :style="{transform:'rotate(' + (-120 + 2/5*240)+ 'deg)'}"><img src="../../../../../public/imgs/cepingreport/page_6_1.png" alt=""></div>
                </div>
                <div class="detail_box">
                    <p class="title">学习焦虑</p>
                </div>
            </div>
            <div class="comment_warp">
                <p class="score">水平值：<span>36</span></p>
                <p class="score">等级：<span>较低</span></p>
                <p class="comment">强学习焦虑低，不会受到太多困扰，能正确对待考试成绩。可继续保持对学习的轻松、良性心态，树立更高的合理目标或找到擅长方向。</p>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    mounted(){
        this.setCanvas()
    },
    methods:{
        setCanvas() {
         //   let canvasId = this.canvasId;
            let ctx = document.getElementById('canvasId').getContext('2d')

            ctx.beginPath(); //起始路径，重置当前路径
            // ctx.strokeStyle="#FCE5E0";
            ctx.strokeStyle="rgba(121,119,119,.1)";

            ctx.lineWidth = 55;  //设置或返回当前的线条宽度。
            ctx.lineCap = 'butt'; //设置或返回线条的结束端点样式。
            ctx.arc(126,127,60, (0.825+2/5*244/180) * Math.PI,(5/5*244/180+0.825)  * Math.PI); //4个刻度平分180°
            ctx.stroke()
            ctx.closePath()

            //橙色圈
            ctx.beginPath(); //起始路径，重置当前路径
            let lingrad = ctx.createLinearGradient(40,20,215,20);//创建线性渐变，颜色渐变
            lingrad.addColorStop(0, '#FDAB74');
            lingrad.addColorStop(1, '#FE8E84');

            ctx.strokeStyle = lingrad; //设置或返回用于笔触的颜色、渐变或模式。
            ctx.lineWidth = 10;  //设置或返回当前的线条宽度。
            ctx.lineCap = 'round'; //设置或返回线条的结束端点样式。

            ctx.arc(127,127,101, 0.825 * Math.PI,(2/5*244/180+0.825) * Math.PI); //4个刻度平分180°
            ctx.stroke()
            ctx.closePath()
        }
    }
}
</script>

<style type="text/css" lang='less' scoped>
.part4_2_main_box {
    margin-top: 80px;
    .main_title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .part4_2_main {
        display: flex;
        .norm_box {
            text-align: center;
            .norm_canvas {
                width: 254px;
                height: 201px;
                position: relative;
                background: url(~@/assets/report_imgs/part4_canvas.png);
                .pointer {
                    position: absolute;
                    height: 194px;
                    left: 113.5px;
                    top: 30px;
                }
            }
            .detail_box {
                p {
                    line-height: 28px;
                    font-size: 16px;
                }
                .title {
                    font-weight: bold;
                }
                .score {
                    color: #8a8a8a;
                    span {
                        font-weight: bold;
                        color: #F8AF3E;
                        font-size: 16px;
                    }
                }
                .norm {
                    color: #8a8a8a;
                    span {
                        font-weight: bold;
                        color: #50CFB1;
                        font-size: 16px;

                    }
                }
            }
        }
        .comment_warp{
            padding: 30px;
            box-sizing: border-box;
            width: 456px;
            .score{
                font-size: 14px;
                font-weight: 500;
                color: #6C6B6B;
                span{
                    color: #00B14B;
                    font-weight: 600;
                }
            }
            .comment {
                font-size: 14px;
                color: #8a8a8a;
                line-height: 28px;
                margin-top: 15px;
            }
    }
        }
        
}
</style>